/* DogSuppy PDP (PL-style) – shared behaviour */
(function () {
  if (window.__dsPdpInit) return;
  window.__dsPdpInit = true;

  var MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var mq = window.matchMedia('(min-width: 768px)');

  function sectionOf(el) { return el.closest('.shopify-section') || el; }

  // Move sections marked data-ds-move="slotname" into matching [data-ds-slot] inside the product column.
  // Elements with data-ds-desktop-gallery (vet quote) always sit directly under the product imagery.
  function gallerySlot(gal, desktop) {
    var cls = desktop ? 'dsp-gallery-slot' : 'dsp-gallery-slot dsp-gallery-slot--m';
    var host = desktop ? (gal.querySelector('.sf-product-media__desktop') || gal) : gal;
    var slot = host.querySelector(desktop ? ':scope > .dsp-gallery-slot:not(.dsp-gallery-slot--m)' : ':scope > .dsp-gallery-slot--m');
    if (!slot) { slot = document.createElement('div'); slot.className = cls; host.appendChild(slot); }
    return slot;
  }
  function placeSections() {
    document.querySelectorAll('[data-ds-move]').forEach(function (el) {
      var sec = sectionOf(el);
      var name = el.getAttribute('data-ds-move');
      var target = null;
      if (el.hasAttribute('data-ds-desktop-gallery')) {
        var gal = document.querySelector('.container-media-gallery');
        if (gal) {
          target = gallerySlot(gal, mq.matches);
          gal.querySelectorAll('.single-review-container').forEach(function (o) { o.style.setProperty('display', 'none', 'important'); });
        }
      }
      if (!target) target = document.querySelector('[data-ds-slot="' + name + '"]');
      if (target && sec.parentNode !== target) target.appendChild(sec);
    });
    // Slots that pull in a whole theme section by id, e.g. data-ds-take="ds_video_reviews"
    document.querySelectorAll('[data-ds-take]').forEach(function (slot) {
      var sec = document.querySelector('.shopify-section[id$="__' + slot.getAttribute('data-ds-take') + '"]');
      if (sec && sec.parentNode !== slot) slot.appendChild(sec);
    });
    placeHead();
  }

  // Opening block (heading, Trustpilot, labels): above the gallery on mobile, top of the product column on desktop.
  function placeHead() {
    var head = document.querySelector('[data-ds-head]');
    if (!head) return;
    var moved = false;
    if (mq.matches) {
      var intro = document.querySelector('.dsp-intro');
      if (intro && intro.firstElementChild !== head) { intro.insertBefore(head, intro.firstChild); moved = true; }
      head.classList.remove('dsp-head--m');
    } else {
      var gal = document.querySelector('.container-media-gallery');
      if (gal && gal.previousElementSibling !== head) { gal.parentNode.insertBefore(head, gal); moved = true; }
      head.classList.add('dsp-head--m');
    }
    if (moved || !head.__tp) {
      head.__tp = 1;
      var w = head.querySelector('.trustpilot-widget');
      var tries = 0;
      (function load() {
        if (w && window.Trustpilot && window.Trustpilot.loadFromElement) { window.Trustpilot.loadFromElement(w, true); }
        else if (tries++ < 40) setTimeout(load, 250);
      })();
    }
  }

  function initTabs(root) {
    root.querySelectorAll('[data-dsp-tabs]').forEach(function (wrap) {
      if (wrap.__dsp) return; wrap.__dsp = 1;
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dsp-tab]');
        if (!b || !wrap.contains(b)) return;
        var id = b.getAttribute('data-dsp-tab');
        wrap.querySelectorAll('[data-dsp-tab]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        wrap.querySelectorAll('[data-dsp-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-dsp-panel') === id); });
      });
    });
  }

  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function initDispatch(root) {
    root.querySelectorAll('.ds-dispatch-card').forEach(function (c) {
      var back = parseInt(c.getAttribute('data-back') || '14', 10);
      var fwd = parseInt(c.getAttribute('data-fwd') || '14', 10);
      var now = new Date();
      var a = new Date(now); a.setDate(now.getDate() - back);
      var b = new Date(now); b.setDate(now.getDate() + fwd);
      var s = c.querySelector('[data-date="sold"]'), n = c.querySelector('[data-date="now"]'), x = c.querySelector('[data-date="next"]');
      if (s) s.textContent = fmt(a);
      if (n) n.textContent = fmt(now);
      if (x) x.textContent = fmt(b);
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-dsp-faq]').forEach(function (faq) {
      if (faq.__dsp) return; faq.__dsp = 1;
      var limit = parseInt(faq.getAttribute('data-limit') || '6', 10);
      var more = faq.querySelector('[data-dsp-more]');
      function show(tab, all) {
        var count = 0, hiddenLeft = 0;
        faq.querySelectorAll('.dsp-faq__item').forEach(function (it) {
          var mine = it.getAttribute('data-tab') === tab;
          it.classList.toggle('is-hidden', !mine);
          if (mine) { count++; var extra = !all && count > limit; it.classList.toggle('is-extra', extra); if (extra) hiddenLeft++; }
          else it.classList.remove('is-extra');
        });
        if (more) more.style.display = hiddenLeft ? '' : 'none';
        faq.setAttribute('data-current', tab);
      }
      faq.querySelectorAll('.dsp-faq__tab').forEach(function (t) {
        t.addEventListener('click', function () {
          faq.querySelectorAll('.dsp-faq__tab').forEach(function (x) { x.classList.toggle('is-active', x === t); });
          show(t.getAttribute('data-tab'), false);
        });
      });
      if (more) more.addEventListener('click', function () { show(faq.getAttribute('data-current'), true); });
      show('1', false);
    });
  }

  function initPopups() {
    document.querySelectorAll('.dsp-pop').forEach(function (p) {
      if (p.parentNode !== document.body) {
        var old = p.id ? document.body.querySelector(':scope > #' + p.id) : null;
        if (old) old.remove();
        document.body.appendChild(p);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-dsp-open]');
    if (open) {
      e.preventDefault();
      var p = document.getElementById(open.getAttribute('data-dsp-open'));
      if (p) p.classList.add('is-open');
      return;
    }
    var pop = e.target.closest('.dsp-pop');
    if (pop && (e.target === pop || e.target.closest('.dsp-pop__close'))) { pop.classList.remove('is-open'); return; }
    var go = e.target.closest('a[data-dsp-scroll]');
    if (go) {
      var t = document.querySelector(go.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  function initCarousels() {
    document.querySelectorAll('[data-dsp-carousel]').forEach(function (wrap) {
      if (wrap.__dsp) return; wrap.__dsp = 1;
      var track = wrap.querySelector('.dsp-track');
      var prev = wrap.querySelector('[data-dsp-prev]'), next = wrap.querySelector('[data-dsp-next]');
      var dotsEl = wrap.querySelector('.dsp-dots');
      if (!track) return;
      function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth)); }
      function page() { return Math.round(track.scrollLeft / track.clientWidth); }
      function render() {
        var n = pages(), p = page();
        if (dotsEl) {
          if (dotsEl.children.length !== n) {
            dotsEl.innerHTML = '';
            for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.className = 'dsp-dot'; b.setAttribute('aria-label', 'Visa ' + (i + 1) + ' av ' + n); (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); })(i); dotsEl.appendChild(b); }
          }
          [].forEach.call(dotsEl.children, function (d, i) { d.classList.toggle('is-active', i === p); });
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        var c = wrap.querySelector('.dsp-controls'); if (c) c.style.display = n > 1 ? '' : 'none';
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(render); }, { passive: true });
      window.addEventListener('resize', render);
      render();
    });
  }

  function init(root) {
    root = root || document;
    placeSections(); initTabs(document); initDispatch(document); initFaq(document); initPopups(); initCarousels();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  if (mq.addEventListener) mq.addEventListener('change', function () { placeSections(); });
  document.addEventListener('shopify:section:load', function () { init(); });
})();
